export const Counties = {
  ALAMANCE: 'Alamance County',
  ALEXANDER: 'Alexander County',
  ALLEGHANY: 'Alleghany County',
  ANSON: 'Anson County',
  ASHE: 'Ashe County',
  AVERY: 'Avery County',
  BEAUFORT: 'Beaufort County',
  BERTIE: 'Bertie County',
  BLADEN: 'Bladen County',
  BRUNSWICK: 'Brunswick County',
  BUNCOMBE: 'Buncombe County',
  BURKE: 'Burke County',
  CABARRUS: 'Cabarrus County',
  CALDWELL: 'Caldwell County',
  CAMDEN: 'Camden County',
  CARTERET: 'Carteret County',
  CASWELL: 'Caswell County',
  CATAWBA: 'Catawba County',
  CHATHAM: 'Chatham County',
  CHEROKEE: 'Cherokee County',
  CHOWAN: 'Chowan County',
  CLAY: 'Clay County',
  CLEVELAND: 'Cleveland County',
  COLUMBUS: 'Columbus County',
  CRAVEN: 'Craven County',
  CUMBERLAND: 'Cumberland County',
  CURRITUCK: 'Currituck County',
  DARE: 'Dare County',
  DAVIDSON: 'Davidson County',
  DAVIE: 'Davie County',
  DUPLIN: 'Duplin County',
  DURHAM: 'Durham County',
  EDGECOMBE: 'Edgecombe County',
  FORSYTH: 'Forsyth County',
  FRANKLIN: 'Franklin County',
  GASTON: 'Gaston County',
  GATES: 'Gates County',
  GRAHAM: 'Graham County',
  GRANVILLE: 'Granville County',
  GREENE: 'Greene County',
  GUILFORD: 'Guilford County',
  HALIFAX: 'Halifax County',
  HARNETT: 'Harnett County',
  HAYWOOD: 'Haywood County',
  HENDERSON: 'Henderson County',
  HERTFORD: 'Hertford County',
  HOKE: 'Hoke County',
  HYDE: 'Hyde County',
  IREDELL: 'Iredell County',
  JACKSON: 'Jackson County',
  JOHNSTON: 'Johnston County',
  JONES: 'Jones County',
  LEE: 'Lee County',
  LENOIR: 'Lenoir County',
  LINCOLN: 'Lincoln County',
  MACON: 'Macon County',
  MADISON: 'Madison County',
  MARTIN: 'Martin County',
  MCDOWELL: 'McDowell County',
  MECKLENBURG: 'Mecklenburg County',
  MITCHELL: 'Mitchell County',
  MONTGOMERY: 'Montgomery County',
  MOORE: 'Moore County',
  NASH: 'Nash County',
  NEW_HANOVER: 'New Hanover County',
  NORTHAMPTON: 'Northampton County',
  ONSLOW: 'Onslow County',
  ORANGE: 'Orange County',
  PAMLICO: 'Pamlico County',
  PASQUOTANK: 'Pasquotank County',
  PENDER: 'Pender County',
  PERQUIMANS: 'Perquimans County',
  PERSON: 'Person County',
  PITT: 'Pitt County',
  POLK: 'Polk County',
  RANDOLPH: 'Randolph County',
  RICHMOND: 'Richmond County',
  ROBESON: 'Robeson County',
  ROCKINGHAM: 'Rockingham County',
  ROWAN: 'Rowan County',
  RUTHERFORD: 'Rutherford County',
  SAMPSON: 'Sampson County',
  SCOTLAND: 'Scotland County',
  STANLY: 'Stanly County',
  STOKES: 'Stokes County',
  SURRY: 'Surry County',
  SWAIN: 'Swain County',
  TRANSYLVANIA: 'Transylvania County',
  TYRRELL: 'Tyrrell County',
  UNION: 'Union County',
  VANCE: 'Vance County',
  WAKE: 'Wake County',
  WARREN: 'Warren County',
  WASHINGTON: 'Washington County',
  WATAUGA: 'Watauga County',
  WAYNE: 'Wayne County',
  WILKES: 'Wilkes County',
  WILSON: 'Wilson County',
  YADKIN: 'Yadkin County',
  YANCEY: 'Yancey County'
} as const;

export type County = typeof Counties[keyof typeof Counties];
